import { render, staticRenderFns } from "./MediumTests.vue?vue&type=template&id=4301317f&scoped=true"
import script from "./MediumTests.vue?vue&type=script&lang=js"
export * from "./MediumTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301317f",
  null
  
)

export default component.exports